import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { shrinkImage } from "../lib/image";
import { toast } from "sonner";

const FK = [["firma", "FİRMA"], ["yetkili", "YETKİLİ"], ["gsm", "GSM"], ["s_tel", "SABİT TEL"], ["email", "EMAIL"], ["adres", "ADRES"], ["il", "İL"], ["ilce", "İLÇE"], ["vergi_dairesi", "VERGİ DAİRESİ"], ["vergi_no", "VERGİ NO"]];

export default function FillInfoModal({ row, left, onClose, onSaved }) {
  const [f, setF] = useState({});
  const [txt, setTxt] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (row) { setF({ ...row.data }); setTxt(""); } }, [row]);
  const merge = (got) => {
    const n = FK.filter(([k]) => k !== "firma" && got[k] && !String(f[k] || "").trim()).length;
    setF((p) => { const o = { ...p }; for (const [k] of FK) if (k !== "firma" && got[k] && !String(o[k] || "").trim()) o[k] = got[k]; if (got.subesi && !o.subesi) o.subesi = got.subesi; return o; });
    toast[n ? "success" : "info"](n ? `${n} EKSİK ALAN DOLDURULDU — KONTROL EDİP KAYDEDİN` : "EKSİK ALANA YAZILACAK YENİ BİLGİ BULUNAMADI");
  };
  const readText = async () => {
    if (!txt.trim()) return;
    setBusy(true);
    try { const r = await api.post("/parse/firma", { text: txt }); merge(r.data); } finally { setBusy(false); }
  };
  const readImgs = async (imgs) => {
    if (!imgs.length) return;
    setBusy(true);
    try {
      const fd = new FormData();
      for (const im of imgs) fd.append("files", await shrinkImage(im));
      const { data } = await api.post("/customers/scan-cards", fd, { headers: { "Content-Type": "multipart/form-data" } });
      const got = {};
      for (const it of data.items || []) for (const [k, v] of Object.entries(it.data || {})) if (v && !got[k]) got[k] = v;
      if (!Object.keys(got).length) toast.error("GÖRSELDEN BİLGİ OKUNAMADI"); else merge(got);
    } catch (e) { toast.error(e.response?.data?.detail || "TARAMA HATASI"); } finally { setBusy(false); }
  };
  const onPaste = (e) => {
    const imgs = [...(e.clipboardData?.items || [])].filter((x) => x.type?.startsWith("image/")).map((x) => x.getAsFile()).filter(Boolean);
    if (imgs.length) { e.preventDefault(); readImgs(imgs); }
  };
  const save = async () => {
    setBusy(true);
    try { await api.put(`/customers/${row.id}`, { data: f, archived: !!row.archived }); toast.success("FİRMA BİLGİLERİ KAYDEDİLDİ"); onSaved(); onClose(); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!row} onOpenChange={(o) => !o && onClose()}>
      <DialogContent key={row?.id} data-testid="fill-info-modal" onPaste={onPaste} className="max-w-3xl border-slate-700 bg-slate-900 text-white">
        <DialogHeader><DialogTitle>EKSİK BİLGİLERİ DOLDUR — {row?.data?.firma}{left > 1 ? ` (SIRADA ${left - 1} FİRMA DAHA)` : ""}</DialogTitle></DialogHeader>
        <textarea data-testid="fill-info-text" value={txt} onChange={(e) => setTxt(e.target.value)} rows={4} placeholder="FİRMA BİLGİ YAZISINI BURAYA YAPIŞTIRIN VEYA EKRAN GÖRÜNTÜSÜNÜ CTRL+V İLE YAPIŞTIRIN" className="w-full rounded-md border border-slate-700 bg-slate-800 p-2 text-xs text-slate-100" />
        <div className="flex gap-2">
          <Button data-testid="fill-info-read-text" disabled={busy || !txt.trim()} onClick={readText} className="h-8 bg-blue-600 text-xs hover:bg-blue-700">YAZIYI OKU</Button>
          <label data-testid="fill-info-pick-image" className="flex h-8 cursor-pointer items-center rounded-md border border-dashed border-sky-700 px-3 text-xs font-bold text-sky-300 hover:bg-sky-950/40">
            EKRAN GÖRÜNTÜSÜ SEÇ<input type="file" accept="image/*" multiple hidden onChange={(e) => { readImgs([...e.target.files]); e.target.value = ""; }} />
          </label>
          {busy && <span data-testid="fill-info-busy" className="self-center text-xs text-sky-300">OKUNUYOR…</span>}
        </div>
        <div className="grid grid-cols-2 gap-2">
          {FK.map(([k, l]) => (
            <label key={k} className="text-[11px] font-bold text-slate-400">{l}
              <Input data-testid={`fill-info-${k}`} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={`h-8 text-xs text-white ${String(f[k] || "").trim() ? "border-slate-700 bg-slate-800" : "border-rose-700 bg-rose-950/30"}`} />
            </label>
          ))}
        </div>
        <div className="flex gap-2">
          <Button data-testid="fill-info-save" disabled={busy} onClick={save} className="h-9 flex-1 bg-emerald-600 hover:bg-emerald-700">KAYDET{left > 1 ? " → SONRAKİ FİRMA" : ""}</Button>
          {left > 1 && <Button data-testid="fill-info-skip" variant="outline" onClick={onClose} className="h-9 border-slate-600 bg-slate-800 text-slate-200">ATLA</Button>}
        </div>
      </DialogContent>
    </Dialog>
  );
}
